<form class="form-inline me-auto d-none d-lg-block me-3" [title]="accountService.account?.organization?.simpleName?.toUpperCase()">
	<div class="input-group input-group-joined input-group-solid org-content">
		<a class="btn btn-light border" (click)="accountService.changeOrganization()">
			<div class="icon">
				Mudar <fa-icon icon="shuffle" class="ps-2 pe-1"></fa-icon>
			</div>
			<div class="org">
				<span class="org-name text-truncate"><b>{{ accountService.account?.organization?.simpleName }}</b></span>
				@if (hasTenantLogo) {
					<img class="tenant-logo" [src]="tenantLogoUrl" alt="Logo do cliente" />
				} @else if (loadingLogo) {
					<span class="tenant-logo-skeleton" aria-hidden="true"></span>
				}
			</div>
		</a>
	</div>
	@if (searchable) {
		<div class="input-group input-group-joined input-group-solid">
			<input class="form-control me-sm-2" type="search" placeholder="Search" aria-label="Search" />
			<div class="input-group-text">
				<i-feather name="search"></i-feather>
			</div>
		</div>
	}
</form>
